import React from 'react'
import PropTypes from 'prop-types'
import { Listbox, Transition } from '@headlessui/react'
import tw, { css } from 'twin.macro'
/**
 * TypeInput - dealer type listbox
 * @param {object} props
 * @param {object} props.selectType search type
 * @param {string} props.selectType.name search type name
 * @param {string} props.selectType.type search type slug
 * @param {() => void} props.onSelectType change search type
 * @returns TypeInput: JSX.Element
 */
const TypeInput = ({ dealerTypes, selectType, onSelectType }) => {
	return (
		<div tw="flex items-center justify-center mb-4">
			<div tw="w-full max-w-sm mx-auto">
				<Listbox
					as="div"
					tw="space-y-1"
					value={selectType}
					onChange={onSelectType}
				>
					{({ open }) => (
						<>
							<Listbox.Label tw="block text-sm leading-5 font-medium text-gray-700 -mt-2">
								Dealer type
							</Listbox.Label>
							<div tw="relative">
								<span tw="inline-block w-full rounded-md shadow-sm">
									<Listbox.Button tw="cursor-default relative w-full rounded-md border border-gray-300 bg-white pl-3 pr-10 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
										<span tw="block truncate">{selectType.name}</span>
										<span tw="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
											<svg
												tw="h-5 w-5 text-gray-400"
												viewBox="0 0 20 20"
												fill="none"
												stroke="currentColor"
											>
												<path
													d="M7 7l3-3 3 3m0 6l-3 3-3-3"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</span>
									</Listbox.Button>
								</span>
								<Transition
									show={open}
									leave="transition ease-in duration-100"
									leaveFrom="opacity-100"
									leaveTo="opacity-0"
									tw="z-20 absolute mt-1 w-full rounded-md bg-white shadow-lg"
								>
									<Listbox.Options
										static
										tw="max-h-60 rounded-md py-1 text-base leading-6 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm sm:leading-5"
									>
										{dealerTypes.map(type => (
											<Listbox.Option key={type.name} value={type}>
												{({ selected, active }) => (
													<div
														css={[
															tw`text-gray-900 cursor-default select-none relative py-2 pl-8 pr-4`,
															active && tw`text-white bg-blue-500`,
														]}
													>
														<span
															css={[
																tw`font-normal block truncate`,
																selected && tw`font-semibold`,
															]}
														>
															{type.name}
														</span>
														{selected && (
															<span
																css={[
																	tw`text-blue-600 absolute inset-y-0 left-0 flex items-center pl-1.5`,
																	active && tw`text-white`,
																]}
															>
																<svg
																	tw="h-5 w-5"
																	xmlns="http://www.w3.org/2000/svg"
																	viewBox="0 0 20 20"
																	fill="currentColor"
																>
																	<path
																		fillRule="evenodd"
																		d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
																		clipRule="evenodd"
																	/>
																</svg>
															</span>
														)}
													</div>
												)}
											</Listbox.Option>
										))}
									</Listbox.Options>
								</Transition>
							</div>
						</>
					)}
				</Listbox>
			</div>
		</div>
	)
}
TypeInput.propTypes = {
	dealerTypes: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			type: PropTypes.string,
		})
	),
	selectType: PropTypes.shape({
		name: PropTypes.string,
		type: PropTypes.string,
	}),
	onSelectType: PropTypes.func,
}
export default TypeInput
